
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 23 19\" id=\"message_icon_jax_9656efb419844aa56356d96ed63f313a\" ><path d=\"M22 7.71c0 3.691-3.082 6.711-6.848 6.711h-2.739L8.761 18v-3.579h-.913C4.082 14.421 1 11.401 1 7.711 1 4.02 4.082 1 7.848 1h7.304C18.918 1 22 4.02 22 7.71z\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></symbol>";
module.exports = sprite.add(image, "message_icon_jax_9656efb419844aa56356d96ed63f313a");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/message_icon.svg
// module id = 1406
// module chunks = 1